
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

const reactPlugin = new ReactPlugin();

export const trackException = (appInsights, error) => {
  appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error });
};

export const trackTrace = (appInsights, trace) => {
  appInsights.trackTrace({ message: trace, severityLevel: SeverityLevel.Information });
};

export const trackEvent = (appInsights, event) => {
  appInsights.trackEvent({ name: event });
};

export default reactPlugin;
